import { filter, map } from 'rxjs';
import { actions } from './actions';
/**
 * Handles incoming request actions by transforming them into execute actions.
 *
 * @param action$ - The stream of actions being dispatched in the system.
 * @returns An Observable that emits execute actions for each request action.
 */
export const handleRequests = (action$) => 
// convert each incoming request action into an execute action for its transaction
action$.pipe(filter(actions.request.match), map((action) => actions.execute(action.meta.transaction)));
//# sourceMappingURL=handle-requests.js.map